﻿'use strict';

angular.module('ntmApp').factory('DailyPlanResourcePoolFilter', ['MultiSelectFilter', 'SimpleFilter', 'HoursCompareFilter', 'DailyPlanService', '$q', function (MultiSelectFilter,SimpleFilter, HoursCompareFilter, DailyPlanService, $q) {

    function DailyPlanResourcePoolFilter(context) {

        var self = this;


        self.multiSelectSettings = {
            idProp:'id',
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 10,
            scrollableHeight: '200px',
            enableSearch: true
        };


        self.checkedActivities ={
            onItemSelect: function () {
                context.CurrentView.ResourcePool.performFiltering();
            },
            onItemDeselect: function () {
                context.CurrentView.ResourcePool.performFiltering();
            },
            onDeselectAll: function () {
                context.CurrentView.ResourcePool.performFiltering();
            }
        };
        self.LocationsFilter = new SimpleFilter(function (item) {
            return '{0} primaries'.format(item);
        });
        self.WeeklyAssignedHoursFilter = new HoursCompareFilter('Assigned {0} {1} hours');
        self.WeeklyAvailableHoursFilter = new HoursCompareFilter('Available {0} {1} hours');
        self.WeeklyOvertimeHoursFilter = new HoursCompareFilter('Overtime {0} {1} hours');
        self.StaffSkillsFilter = new SimpleFilter();
        self.ByRoomSkillsFilter = new SimpleFilter(function (item) {
            if (item) {
                return item + " Skills";
            }
            else {
                return undefined;
            }
        });
        self.BySkillSetFilter = new SimpleFilter(function (item) {
            if (item) {
                return item;
            }
            else {
                return undefined;
            }
        });
        
        self.ByActivityFilter = new MultiSelectFilter("",(function (item) {
            if (item) {
                return "Skills: " + item.replaceAll(';', ',');
            }
            else {
                return undefined;
            }
        }));

        self.ByRoomSkillsFilter.clearStaffSkillsFilter = true;
        self.BySkillSetFilter.clearStaffSkillsFilter = true;
        self.ByActivityFilter.clearStaffSkillsFilter = true;

        self.getfilters = function () {
            return [
                self.LocationsFilter,
                self.WeeklyAssignedHoursFilter,
                self.WeeklyAvailableHoursFilter,
                self.WeeklyOvertimeHoursFilter,
                self.StaffSkillsFilter,
                self.ByRoomSkillsFilter,
                self.BySkillSetFilter,
                self.ByActivityFilter
            ];
        };

        self.getAppliedFilters = function () {
            return self.getfilters().filter(function (filter) {
                return filter.isDefined() && filter !== self.StaffSkillsFilter;
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getfilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.isDefault = function () {

            return !self.LocationsFilter.filterItem &&
                   !self.WeeklyAssignedHoursFilter.isPartlyDefined() &&
                   !self.WeeklyAvailableHoursFilter.isPartlyDefined() &&
                   !self.WeeklyOvertimeHoursFilter.isPartlyDefined() &&
                   !self.ByRoomSkillsFilter.isPartlyDefined() &&
                   !self.BySkillSetFilter.isPartlyDefined() &&
                   !self.ByActivityFilter.isPartlyDefined();
        };

        self.load = function () {

            var deferred = $q.defer();
            var request = context.getViewModeSelectedDateAndLocation();

            DailyPlanService.GetResourcePoolFilters(request).then(function (result) {
                if (result.success) {
                    self.dataSource.locations = result.data.locations;
                    self.dataSource.rooms = result.data.rooms;
                    self.dataSource.skillSets = result.data.skillSets;
                    self.dataSource.activities = result.data.activities;
                }

                deferred.resolve();
            });

            return deferred.promise;
        };

        self.clearAllFilters = function () {
            self.getfilters().forEach(function (filter) {
                filter.clear();
            });
        };

        self.revertFilters = function () {
            self.clearAllFilters();
        };

        self.filterStaff = function (staffs) {

            var result = [];
            
            staffs.forEach(function (staff) {

                if (self.LocationsFilter.isDefined()) {

                    if (!isInLocation(staff)) {
                        return;
                    }
                }

                if (self.WeeklyAssignedHoursFilter.isDefined()) {

                    var WeeklyAssignedHoursFilterResult = self.WeeklyAssignedHoursFilter.hoursComparator === '>=' ? staff.assigned >= self.WeeklyAssignedHoursFilter.hours :
                                               staff.assigned <= self.WeeklyAssignedHoursFilter.hours;

                    if (!WeeklyAssignedHoursFilterResult) {
                        return;
                    }

                }

                if (self.WeeklyAvailableHoursFilter.isDefined()) {

                    var WeeklyAvailableHoursFilterResult = self.WeeklyAvailableHoursFilter.hoursComparator === '>=' ? staff.available >= self.WeeklyAvailableHoursFilter.hours :
                           staff.available <= self.WeeklyAvailableHoursFilter.hours;

                    if (!WeeklyAvailableHoursFilterResult) {
                        return;
                    }
                }

                if (self.WeeklyOvertimeHoursFilter.isDefined()) {

                    var WeeklyOvertimeHoursFilterResult = self.WeeklyOvertimeHoursFilter.hoursComparator === '>=' ? staff.overtime >= self.WeeklyOvertimeHoursFilter.hours :
                           staff.overtime <= self.WeeklyOvertimeHoursFilter.hours;

                    if (!WeeklyOvertimeHoursFilterResult) {
                        return;
                    }
                }


                if (self.ByActivityFilter.isDefined()) {

                    var hasSkills = false;

                    if (staff.allTargetStaffSkill && staff.allTargetStaffSkill.length && staff.allTargetStaffSkill[0]) {

                        var staffActivityIds = staff.allTargetStaffSkill[0].staffSkillsForActivityList.map(function (staffActivitySkills) {
                            return staffActivitySkills.activityId;
                        });

                        hasSkills = self.ByActivityFilter.selectedItems.every(item => staffActivityIds.includes(item.id));
                    }

                    if (!hasSkills) {
                        return;
                    }
                }


                if (self.StaffSkillsFilter.isDefined()) {

                    var suitableStaffSkillsCount = 0;

                    staff.filterData = null;

                    if (self.StaffSkillsFilter.filterItem === "byRoom" || self.StaffSkillsFilter.filterItem.value === "byRoom" && self.ByRoomSkillsFilter.filterItem) {
                        if (staff.allTargetStaffSkill && staff.allTargetStaffSkill.length && staff.allTargetStaffSkill[0]) {
                            staff.allTargetStaffSkill[0].staffSkillsForActivityList.forEach(function (staffActivitySkills) {
                                var staffActivitySpeciesList = staffActivitySkills.staffSkills && staffActivitySkills.staffSkills.length ? staffActivitySkills.staffSkills.split(';') : [];

                                self.ByRoomSkillsFilter.filterItem.activities.forEach(function (roomActivity) {
                                    if (staffActivitySkills.activityId === roomActivity.activityId) {
                                        if (roomActivity.speciesCode) {
                                            if (staffActivitySpeciesList && staffActivitySpeciesList.length && staffActivitySpeciesList.length > 0) {
                                                var hasStaffSuitableSpec = staffActivitySpeciesList.some(function (staffActivitySpeciesCode) {
                                                    return staffActivitySpeciesCode === roomActivity.speciesCode;
                                                });

                                                if (hasStaffSuitableSpec) {
                                                    suitableStaffSkillsCount += 1;
                                                }
                                            } else {
                                                suitableStaffSkillsCount += 1;
                                            }
                                        } else {
                                            suitableStaffSkillsCount += 1;
                                        }
                                    }
                                });
                            });
                        }

                        if (!suitableStaffSkillsCount || suitableStaffSkillsCount === 0) {
                            return;
                        }

                        staff.filterData = {
                            selectedFilterLabel: self.ByRoomSkillsFilter.filterItem.value,
                            suitableStaffSkillsCount: suitableStaffSkillsCount,
                            totalSkillsCount: self.ByRoomSkillsFilter.filterItem.activities.length
                        };

                    } else if (self.StaffSkillsFilter.filterItem === "bySkillSet" || self.StaffSkillsFilter.filterItem.value === "bySkillSet" && self.BySkillSetFilter.filterItem) {

                        if (staff.allTargetStaffSkill && staff.allTargetStaffSkill.length && staff.allTargetStaffSkill[0]) {
                            staff.allTargetStaffSkill[0].staffSkillsForActivityList.forEach(function (staffActivitySkills) {
                                var staffActivitySpeciesList = staffActivitySkills.staffSkills && staffActivitySkills.staffSkills.length ? (staffActivitySkills.staffSkills.split(';')).filter(function (staffSkillsItem) { return staffSkillsItem.length !== 0; }) : [];

                                self.BySkillSetFilter.filterItem.activities.forEach(function (skillSetActivity) {
                                    if (staffActivitySkills.activityId === skillSetActivity.id) {
                                        if (self.BySkillSetFilter.filterItem.skillSetSpecies && self.BySkillSetFilter.filterItem.skillSetSpecies.length && self.BySkillSetFilter.filterItem.skillSetSpecies.length > 0) {
                                            var skillSetSpeciesList = (self.BySkillSetFilter.filterItem.skillSetSpecies.split(';') || []).filter(function (speciesItemElement) { return speciesItemElement.length !== 0; });

                                            if (staffActivitySpeciesList && staffActivitySpeciesList.length && staffActivitySpeciesList.length > 0) {
                                                var suitableStaffSkillsSpeciesCount = 0;

                                                skillSetSpeciesList.forEach(function (skillSetSpec) {
                                                    var isStaffActivitySpeciesItemSuitable = staffActivitySpeciesList.filter(function (staffActivitySpeciesCode) {
                                                        return staffActivitySpeciesCode === skillSetSpec;
                                                    });

                                                    if (isStaffActivitySpeciesItemSuitable) {
                                                        suitableStaffSkillsSpeciesCount++;
                                                    }
                                                });

                                                if (suitableStaffSkillsSpeciesCount === skillSetSpeciesList.length) {
                                                    suitableStaffSkillsCount += 1;
                                                }
                                            } else {
                                                suitableStaffSkillsCount += 1;
                                            }
                                        } else {
                                            suitableStaffSkillsCount += 1;
                                        }
                                    }
                                });
                            });
                        }

                        if (!suitableStaffSkillsCount || suitableStaffSkillsCount === 0) {
                            return;
                        }

                        staff.filterData = {
                            selectedFilterLabel: self.BySkillSetFilter.filterItem.value,
                            suitableStaffSkillsCount: suitableStaffSkillsCount,
                            totalSkillsCount: self.BySkillSetFilter.filterItem.activities.length
                        };
                    }
                } else {
                    staff.filterData = null;
                }
                
                result.push(staff);

            });

            return result;
        };
        
        function isInLocation(staff) {
            return self.LocationsFilter.filterItem.primaries.some(function (item) {
                return item === staff.personId;
            });
        }

        function initialize() {
            self.dataSource = {};
        }

        initialize();
    }

    return (DailyPlanResourcePoolFilter);

}]);